import axios from 'axios';
import qs from 'qs';

const fetchData = (accessScope?: string) => {
  return {
    client_id: process.env.MICROSOFT_ONLINE_CLIENT_ID,
    scope: accessScope,
    client_secret: process.env.MICROSOFT_ONLINE_CLIENT_SECRET,
    grant_type: process.env.MICROSOFT_ONLINE_GRANT_TYPE,
  };
};

export const fetchAccessToken = (accessScope?: string) => {
  return axios.get(`${process.env.ACCESS_TOKEN_FETCH_URL}`, {
    data: qs.stringify(fetchData(accessScope)),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};
